module.exports = __webpack_public_path__ + "static/2-5dd15b4b00412a72d5b5e7a335e0c4bf.jpg";